import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section section-padding">
      <div className="container">
        <div className="about-grid">
          <div className="about-image-container fade-in">
            <div className="about-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1673865641073-4479f93a7776?crop=entropy&cs=srgb&fm=jpg&q=85" 
                alt="Dr. Asha" 
                className="about-image"
              />
              <div className="about-accent-box"></div>
            </div>
          </div>
          
          <div className="about-content fade-in">
            <h2 className="heading-1">Welcome to Vibe Dental Studio.</h2>
            <div className="about-divider"></div>
            <p className="body-large about-text">
              Founded by <strong>Dr. Asha</strong>, Vibe Dental Studio blends modern dental technology with a warm, luxurious atmosphere. We believe your smile deserves both precision and comfort.
            </p>
            <p className="body-regular about-subtext">
              With over 15 years of experience in advanced dental care, our team is dedicated to providing exceptional treatments in a calming environment. Every patient receives personalized care tailored to their unique needs.
            </p>
            <div className="about-stats">
              <div className="stat-item">
                <h3 className="heading-2">15+</h3>
                <p className="body-small">Years Experience</p>
              </div>
              <div className="stat-item">
                <h3 className="heading-2">5000+</h3>
                <p className="body-small">Happy Patients</p>
              </div>
              <div className="stat-item">
                <h3 className="heading-2">100%</h3>
                <p className="body-small">Patient Satisfaction</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;